import { BudgetingScenario } from '../types/BudgetingScenario'

const budgetingScenarioEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/budgeting/budgeting-scenarios` as const,
  detail: (companyId: string, scenarioId: BudgetingScenario['id']) =>
    `/companies/${companyId}/budgeting/budgeting-scenarios/${scenarioId}` as const,
  lock: (companyId: string, scenarioId: BudgetingScenario['id']) =>
    `/companies/${companyId}/budgeting/budgeting-scenarios/${scenarioId}/lock` as const,
  unLock: (companyId: string, scenarioId: BudgetingScenario['id']) =>
    `/companies/${companyId}/budgeting/budgeting-scenarios/${scenarioId}/unlock` as const
}

export default budgetingScenarioEndpoints
